"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const WinterTiresLabelView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/WinterTiresLabelView"));
const AvailabilityLabelView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/AvailabilityLabelView"));
const MergedOfferLabelsView = ({ listingOffer, }) => react_1.default.createElement("div", { className: "labels" },
    listingOffer.simpleOfferList.hasAnySimpleOfferWinterTires() && react_1.default.createElement(WinterTiresLabelView_1.default, null),
    react_1.default.createElement(AvailabilityLabelView_1.default, { description: listingOffer.simpleOfferList.allOffersHaveSameAvailability()
            ? listingOffer.simpleOfferList.getFirstOffer().availabilityDescription
            : 'Více možností dostupnosti' }));
exports.default = MergedOfferLabelsView;
